import {
  GET_ALL_ASSIGNMENTS,
  GET_ALL_SUB_ASSIGNMENTS,
  GET_ASSIGNMENT,
  GET_SUB_ASSIGNMENT,
} from "../actions/actionTypes";

const initialState = {
  assignments: [],
  subAssignments: [],
  selectedAssignment: null,
  selectedSubAssignment: null,
};

export default function assignments(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_ASSIGNMENTS:
      return {
        ...state,
        assignments: action.payload.data || [],
      };
    case GET_ALL_SUB_ASSIGNMENTS:
      return {
        ...state,
        subAssignments: action.payload.data.tasks || [],
      };
    case GET_SUB_ASSIGNMENT:
      return {
        ...state,
        selectedSubAssignment: action.payload.data || [],
      };
    case GET_ASSIGNMENT:
      return {
        ...state,
        selectedAssignment: action.payload.data,
      };
    default:
      return state;
  }
}
